// Contact store module - handles contact form submissions
const API_BASE = process.env.VUE_APP_API_BASE;
const API_EMPRENDIMIENTO = `${API_BASE}/ajax/contactoemprendimiento.php`;

export default {
  namespaced: true,

  state: {
    submissions: [],
    loading: false,
    error: null,
    successMessage: null,
  },

  getters: {
    getAllConsultorias: (state) => state.submissions,
    getUnreadSubmissions: (state) => {
      return state.submissions.filter((sub) => !sub.read)
    },
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
    getSuccessMessage: (state) => state.successMessage,
  },

  mutations: {
    SET_SUBMISSIONS(state, consultorias) {
      state.submissions = consultorias
    },
    ADD_SUBMISSION(state, submission) {
      state.submissions.unshift(submission)
    },
    MARK_SUBMISSION_READ(state, submissionId) {
      const submission = state.submissions.find((s) => s.id_consultorias === submissionId)
      if (submission) {
        submission.read = true
      }
    },
    DELETE_SUBMISSION(state, submissionId) {
      state.submissions = state.submissions.filter((s) => s.id_consultorias !== submissionId)
    },
    UPDATE_SUBMISSION_VIGENTE(state, { id, vigente }) {
      const submission = state.submissions.find((s) => s.id_consultorias === id)
      if (submission) submission.vigente = vigente
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SUCCESS_MESSAGE(state, message) {
      state.successMessage = message
    },
    CLEAR_MESSAGES(state) {
      state.error = null
      state.successMessage = null
    },
  },

  actions: {
    async fetchSubmissions({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_EMPRENDIMIENTO}?action=getAll`)
        const data = await response.json()

        if (data.success) {
          commit("SET_SUBMISSIONS", data.consultorias)
          return { success: true, count: data.consultorias?.length || 0 }
        } else {
          commit("SET_ERROR", data.message || "Error al cargar mensajes")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error fetching submissions:", error)
        commit("SET_ERROR", "Error de conexión al cargar mensajes")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async submitConsultoriaForm({ commit }, consultoriaData) {
      commit("SET_LOADING", true)
      commit("CLEAR_MESSAGES")
      try {
        const response = await fetch(`${API_EMPRENDIMIENTO}?action=add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(consultoriaData),
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_SUCCESS_MESSAGE", "Mensaje enviado correctamente. Nos pondremos en contacto pronto.")
          return { success: true }
        } else {
          commit("SET_ERROR", data.message || "Error al enviar el mensaje")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error submitting contact form:", error)
        commit("SET_ERROR", "Error de conexión al enviar el mensaje")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    /* ♻️ Cambiar vigencia (toggle) */
    async toggleVigente({ dispatch }, { id, vigente }) {
      try {
        const res = await fetch(`${API_EMPRENDIMIENTO}?action=setVigente`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, vigente }),
        })
        const data = await res.json()
        if (data.success) {
          await dispatch("fetchSubmissions")
        }
        return data
      } catch (err) {
        console.error("Error toggleVigente:", err)
        return { success: false }
      }
    },

    async deleteSubmission({ commit }, submissionId) {
      try {
        const response = await fetch(`${API_EMPRENDIMIENTO}?action=delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("DELETE_SUBMISSION", submissionId)
          return { success: true }
        } else {
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("[v0] Error deleting submission:", error)
        return { success: false, message: "Error de conexión" }
      }
    },

    clearMessages({ commit }) {
      commit("CLEAR_MESSAGES")
    },
  },
}
